import React, { FC } from 'react';
import getClassName from 'src/common/utils/getClassName';
import s from './CalendarControls.module.scss';

type CalendarControlsProps = {
  classNameModifier?: string;
};

const CalendarControls: FC<CalendarControlsProps> = ({
  children,
  classNameModifier = '',
}) => (
  <div className={getClassName(s, 'root', `${classNameModifier}`)}>
    {children}
  </div>
);

export default CalendarControls;
